import React from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {UspsStripeBanner} from './UspsStripeBanner'
import {BaeGuardStripeBanner} from './BaeGuardStripeBanner'

// Global header stripe stack. Render order == stacking priority (top → bottom).
// Email Verification (TopAlert) renders above this in MasterLayout per PRD D2.
const GlobalBannerStack: React.FC = () => {
  const {currentUser} = useAuth()
  if (!currentUser) return null

  return (
    <>
      <UspsStripeBanner />
      <BaeGuardStripeBanner />
    </>
  )
}

export {GlobalBannerStack}
